import { createPerimeter } from 'vue-kindergarten';
import { isLoggedIn} from '../utilities/roleUtilities';
import { getRoutes } from '../utilities/roleRoutes';

export const SidebarPerimeter = createPerimeter({
    purpose: 'viewSidebar',

    can: {
        viewLink (pageName) {
            let routes = getRoutes();
            return isLoggedIn(this.child) && routes[this.child.role].includes(pageName);
        }
    }
});
